import { useTranslation } from "react-i18next";
import { EventCard } from "../EventCard";

interface Props {
  isResearching: boolean;
}

export const EventStatus = ({ isResearching }: Props) => {
  const { t } = useTranslation();
  const status = !isResearching
    ? t("research.research_end")
    : t("research.research_start");

  return <EventCard eventType={"status"} eventBody={<div>{status}</div>} />;
};
